<template>
<div>

<div   class="modal" id="productGridModal"  data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content border-primary">
      <div class="modal-header bg-primary">
        <h5 class="modal-title text-white" id="staticBackdropLabel">
          <i style="color:yellow"  class="far fa-id-card mr-3" aria-hidden="true"></i>
          INFO VARIANTI PRODOTTO  </h5>
      </div>
      <div class="border border-warning bg-warning">
        <h4><span  style="color:black" class="mb-1 ml-2"><strong>{{productData.title}}</strong></span></h4>  
      </div>
      
      <form>
      <div class="modal-body">
        <div class="row">
            <div class="col-4">
                <div v-if="err">
                    <img src="@/assets/no_img.jpg" alt="" class="align-self-center mr-3" width="250" height="250" style="border:1px solid black">
                </div>
                <div v-else>
                    <img :src="productData.img" @error="err=true"   alt="" width="250" height="250" style="border:2px solid green" class="align-self-center mr-3">                      
                </div>
            </div>    
            <div class="col">

                <productGrid v-bind:cols="productData.cols" v-bind:rows="productData.rows"></productGrid>
          
             </div>

        
        </div>
        
      </div>

      <div class="modal-footer">
        <button  @click="closeModal()" type="button" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>        
      </div>

</form>  

</div>
</div>
</div>
</div>
</template>
<script>

import productGrid     from '@/components/stat/ProductGrid.vue'


export default {
  props: ['productData'],
  components : {productGrid},
  data () {
    return {
     
      img        : '',
      err        : ''  
     
    
    }
  },

   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  created: function()
  {
    console.log(this.productData)
    this.$nextTick(()  => {   

        $('#productGridModal').modal('show')
    
        
    
    })  
    

  },  
  mounted()
    {
            
      
    },
  methods: 
    {
    closeModal()
    {
      $('#productGridModal').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    
    },

      
    
    
    }
  
}
</script>
<style scoped>
    
</style>

